<template>
  <div class="w-full">
    <div class="flex items-center justify-between py-5">
      <div class="flex items-center space-x-3 text-darkestGray">
        <span class="font-bold text-primary"> {{ index + 1 }}. </span>

        <img
          :src="useAsset(`icons/base/${patient.age}.svg`)"
          loading="lazy"
          :alt="`${patient.age}-patient-icon`"
          class="w-6"
        />
        <span class="font-bold text-primary">
          {{ fullName }}
        </span>
        <button
          v-if="
            patient.age !== 'kid' ||
            (isUUID(patient.id) && patient.age === 'kid')
          "
          class="transition-ease-in-out flex items-center space-x-2 hover:opacity-70"
          @click="onShowEditModal"
        >
          <img
            src="~/assets/icons/base/edit.svg"
            class="transform"
            loading="lazy"
            alt="edit-icon"
          />
        </button>
      </div>
      <div v-if="selectedExamination" class="flex space-x-3">
        <button
          v-if="!isAssigned"
          class="transition-ease-in-out flex h-10 w-10 items-center space-x-3 rounded-3xl border border-gray bg-white p-px pr-0 hover:opacity-70 lg:w-[140px] lg:pr-4"
          :class="[
            {
              'cursor-not-allowed opacity-50': isDisabled,
            },
          ]"
          @click="!isDisabled && $emit('assign', patient)"
        >
          <div
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-white"
          >
            <inline-svg :src="useAsset(`icons/base/plus.svg`)" />
          </div>

          <span class="hidden text-sm font-medium text-primary lg:block">
            {{ $t('action.assign') }}
          </span>
        </button>

        <button
          v-else
          class="transition-ease-in-out flex h-10 w-10 items-center justify-end rounded-3xl border border-primary bg-primary pl-0 lg:w-[140px] lg:pl-4"
          @click="$emit('remove', patient.id)"
        >
          <span class="mr-3 hidden text-sm font-medium text-white lg:block">
            {{ $t('patients.assigned') }}
          </span>
          <div
            class="mr-px flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white"
          >
            <inline-svg :src="useAsset(`icons/base/check.svg`)" />
          </div>
        </button>
      </div>
    </div>
    <hr class="border-t-2 border-lightGray" />
  </div>
</template>

<script setup>
import InlineSvg from 'vue-inline-svg'
import { useCartStore } from '~~/stores/cart'
import { useModalsStore } from '~~/stores/modals'

const props = defineProps({
  index: {
    type: [Number, String],
    required: true,
  },
  patient: {
    type: [Object],
    required: true,
  },
  isAssigned: {
    type: [Boolean],
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['assign', 'remove'])

const cartStore = useCartStore()
const modalsStore = useModalsStore()

const fullName = computed(() => {
  return `${props.patient.first_name} ${props.patient.last_name}`
})

const selectedExamination = computed(() => {
  return cartStore.selectedExamination
})

const onShowEditModal = () => {
  cartStore.selectedPatient = { ...props.patient }
  modalsStore.open('editPatientModal')
}
const isUUID = (str) => {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    str
  )
}
</script>
